"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsideCard = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Card = _interopRequireDefault(require("../Card"));

var _Card2 = require("../Card/Card.styles");

var _helperFunctions = require("../../../../styles/helperFunctions");

var _card = require("../../../../styles/2_commonComponentStyles/card");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AsideCard = (0, _styledComponents.default)(_Card.default).withConfig({
  displayName: "AsideCardstyles__AsideCard",
  componentId: "sc-1bnkq2w-0"
})(["", ";", "{padding:", ";}@media only screen and (min-width:", "){max-width:", ";width:auto;}"], _card.responsiveCard, _Card2.StyledCardBody, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}, function (props) {
  return props.theme.mediumBreak;
}, function (props) {
  return props.theme.cardAside;
});
exports.AsideCard = AsideCard;